import React from "react";
import { NAV_LINKS } from "../../router/navlinks";
import { StyledSideBar } from "./styles";
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { matchPath } from "react-router-dom";
import { userActions } from "../../store/actions";
const SideBar = () => {
  const { pathname } = useLocation();
  const { accessibleRoutes = [] } = useSelector((store) => store.user);
  const dispatch = useDispatch();
  const accesibleLinks = NAV_LINKS.filter((link) => {
    return accessibleRoutes.some((tmpLink) =>
      matchPath(link.path, tmpLink.path)
    );
  });
  return (
    <StyledSideBar>
      <ul className="tma__nav_links">
        {accesibleLinks.map((link) => {
          const { icon: NavIcon } = link;
          return (
            <li
              className={`tma__nav_link_item ${
                pathname === link.path ? "active-item" : ""
              }`}
              key={link.path}
            >
              <NavLink
                to={link.path}
                onClick={() => dispatch(userActions.setSidebar(false))}
              >
                <span>
                  <NavIcon />
                </span>
                <span>{link.title}</span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </StyledSideBar>
  );
};

export default SideBar;
